import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA, with auto-update on new deploys.
// This fixes the historical bug where a stale cached HTML pointed at JS
// bundles that no longer exist on the server (causing "buttons don't click").
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Check for updates every time the app is opened
        reg.update().catch(() => {});

        // When a new SW takes control, refresh once so the page runs the
        // freshly-fetched HTML + JS bundles (no more stale-cache lockout).
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        // Listen for new SW installations (waiting state)
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW is waiting; activate it immediately
              installing.postMessage?.({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {});
  });
}

// Disable right-click context menu on media
document.addEventListener('contextmenu', (e) => {
  if (e.target.tagName === 'VIDEO' || e.target.tagName === 'IMG' || e.target.tagName === 'IFRAME') {
    e.preventDefault();
  }
});

// Disable keyboard shortcuts for saving
document.addEventListener('keydown', (e) => {
  if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
